import React from "react";

import AppointmentList from "./consultant/appointmentList";



const Appointment = () => {


  return (
    <div className="bg-gray-50 min-sh-screen">
      <AppointmentList />
    </div>
  );
};

export default Appointment;
